import Axios from 'axios'
import {

  SET_MODULE_NAME,
  SET_PROJECT_INFO,
  SEARCH_DISBURSEMENT_DATA,
  UNSET_SEARCH_DISBURSEMENT_DATA,

  SET_KEY_VALUE,
  UNSET_KEY_VALUE,

  SET_RE_PAYMENT_DATA,
  UNSET_RE_PAYMENT_DATA,

  SET_COMMON_DATA,
  UNSET_COMMON_DATA,

  SET_VOUCHER_ENTRY_DATA,
  UNSET_VOUCHER_ENTRY_DATA,

} from '../mutation-types'

const state = {
  moduleName:'',
  projectInfo:'',
  disbursementData:'',
  keyValue:0,
  rePaymentData:'',
  commonData:'',
  voucherEntryData: '',
}

const getters = {
  GET_MODULE_NAME(state) {
    return state.moduleName;
  },
  GET_PROJECT_INFO(state) {
    return state.projectInfo;
  },
  GET_SEARCH_DISBURSEMENT_DATA(state) {
    return state.disbursementData;
  },
  GET_KEY_VALUE(state) {
    return state.keyValue;
  },

  GET_RE_PAYMENT_DATA(state) {
    return state.rePaymentData;
  }, 
  GET_COMMON_DATA(state) {
    return state.commonData;
  },
  GET_VOUCHER_ENTRY_DATA(state) {
    return state.voucherEntryData;
  },

}

// mutations
const mutations = {

  [SET_MODULE_NAME](state, moduleTitle) {
    state.moduleName = moduleTitle
  },
  [SET_PROJECT_INFO](state, projectInfo) {
    state.projectInfo = projectInfo
  },
  [SEARCH_DISBURSEMENT_DATA](state, disbursementData) {
    state.disbursementData = disbursementData
  },
  [UNSET_SEARCH_DISBURSEMENT_DATA](state, disbursementData) {
    state.disbursementData = '';
  },

  [SET_KEY_VALUE](state, keyValue) {
    state.keyValue = '';
    state.keyValue = keyValue;
  },
  [UNSET_KEY_VALUE](state, keyValue) {
    state.keyValue = '';
  },

  [SET_RE_PAYMENT_DATA](state, rePaymentData) {
    state.rePaymentData = rePaymentData;
  },
  [UNSET_RE_PAYMENT_DATA](state, rePaymentData) {
    state.rePaymentData = '';        
  }, 
  [SET_COMMON_DATA](state, commonData) {
    state.commonData = commonData;        
  },
  [UNSET_COMMON_DATA](state, commonData) {
    state.commonData = '';        
  }, 

  [SET_VOUCHER_ENTRY_DATA](state, voucherEntryData) {
    state.voucherEntryData = voucherEntryData;
  },
  [UNSET_VOUCHER_ENTRY_DATA](state, voucherEntryData) {
    state.voucherEntryData = '';
  },

}

// Actions
const actions = {}
export default {
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/vuex/module/bd_bank_module.js